import { Ref } from "preact/hooks";

export interface InputProps {
  id: string;
  placeholder?: string;
  inputRef?: Ref<HTMLInputElement>;
  error?: string;
  classes?: string;
  name?: string;
  type?: string;
  checked?: boolean;
  onInput?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function Input(
  { id, placeholder, inputRef, error, classes, type, onInput, name, checked }:
    InputProps,
) {
  return (
    <div class="flex flex-col w-full lg:w-auto justify-end">
      <input
        id={id}
        ref={inputRef}
        type={type}
        name={name}
        checked={checked}
        class=""
        placeholder={error ? error : placeholder}
        className={`${
          error ? "placeholder-[#DC5959]" : "placeholder-black"
        } border-b border-black border-solid outline-none placeholder:bg-transparent ${classes}`}
        onInput={onInput}
      />
    </div>
  );
}
